import React, { ChangeEvent } from "react";
import Form from "react-bootstrap/Form";
import Field from "./Field";

interface InputProps {
  label?: React.ReactNode;
  value?: string;
  border?: string;
  margin?: string;
  placeholder?: string;
  svg?: React.ReactNode;
  icon?: string;
  hint?: string;
  error?: string;
  required?: boolean;
  maxLength?: number;
  showCounter?: boolean;
  rightSlot?: React.ReactNode;
  name?: string;
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
  onKeyDown?: (e: any) => void;
  parentStyles?: React.CSSProperties;
}

const Text: React.FC<InputProps> = ({
  label,
  value,
  placeholder,
  svg,
  border,
  margin,
  icon,
  hint,
  error,
  required,
  maxLength,
  showCounter,
  rightSlot,
  name,
  onChange,
  onKeyDown,
  parentStyles,
  ...rest
}) => {
  return (
    <Field
      label={label}
      margin={margin}
      icon={icon}
      iconNode={svg}
      hint={hint}
      error={error}
      required={required}
      maxLength={maxLength}
      showCounter={showCounter}
      currentLength={value?.length}
      rightSlot={rightSlot}
      style={parentStyles}
    >
      <Form.Control
        className={border}
        type="text"
        name={name}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        onKeyDown={(e: any) => (onKeyDown ? onKeyDown(e) : null)}
        maxLength={maxLength}
        {...rest}
      />
    </Field>
  );
};

export default Text;
